import { useMemo } from "react";
import { getTenantSettings as getBaseTenantSettings } from "shared/config";
import { DiseaseConfig } from "shared/model/diseases";
import { OrganisationConfig } from "shared/model/organisations";
import {
  FrontendPage,
  FrontendPageEnum,
  PageSettings,
} from "shared/model/pages";

import { useTenantId } from "./util/use-active-tenant-id";

export type TenantConfig = Omit<
  DiseaseConfig | OrganisationConfig,
  "enabledPages"
>;

export const useTenantConfig = (): TenantConfig => {
  return useTenantConfigInternal();
};

export const usePageSettings = <Page extends FrontendPageEnum>(
  page: Page,
): PageSettings<Page> | undefined => {
  const config = useTenantConfigInternal();

  return useMemo(
    () =>
      (
        config.enabledPages?.find(
          (enabledPage) => enabledPage.route === page,
        ) as FrontendPage<Page> | undefined
      )?.settings,
    [config.enabledPages, page],
  );
};

const useTenantConfigInternal = (): DiseaseConfig | OrganisationConfig => {
  const tenantId = useTenantId();
  return useMemo(() => getBaseTenantSettings(tenantId), [tenantId]);
};
